import {
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material";
import { orderBy as _orderBy } from 'lodash';
// import ConfirmationDialog from "controls/global/dialogs/confirmation-dialog";
import TooltipCell from "controls/global/stewart-table/TooltipCell";
import { SignatureDefaultGroup } from "entities/UIModel/SignatureDefaultGroup";
import { useSignatureDefaultDialogProvider } from "pages/signatures/providers/signature-defaults/SignatureDefaultDialogProvider";
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  borderRadius,
  borderSize,
  colors,
  defaultStyle,
  fontSize,
  fontWeight,
  margin,
  padding,
} from "theme/defaultStyle";
import { useSignatureDefaults } from "utils/context/SignatureDefaultsContext";
import { useSignatures } from "utils/context/SignaturesContext";
// import SignatureDefaultsTableHeader from "./SignatureDefaultsTableHeader";
// import { useProfileSettingsCache } from "utils/context/ProfileSettingsContext";
// import { PERMISSIONS } from "utils/data/enum";
import { useGlobalAccess } from "utils/context/GlobalAccessContext";
import StewartTable, { StewartTableColumn } from "controls/global/stewart-table/StewartTable";
import CustomTooltip from "controls/global/custom-tooltip";
import EditIcon from '@mui/icons-material/Edit';
import { Order } from "utils/sorting";
import DeleteIcon from "@mui/icons-material/Delete";
import { showToast } from "controls/global/stewart-toast/showToast";
import { 
  debounce, 
} from "lodash";
import { useConfigContext } from "utils/context/ConfigContextProvider";
import { useMyFiles } from "utils/context/MyFilesContext";
import SignatureAllViewModal from "../signature-dialog/SignatureAllViewModal";
import { formatDateRegEx, toBase64 } from "utils/shared";
import SignatureConfirmationDialog from "../signature-confirmation-dialog/SignatureConfirmationDialog";
import { getSignatureActionLabels } from "utils/services/utilsService";
import { UIConstants } from "utils/data/enum";
import { IColumn } from "entities/ApiModel/IColumn";
import CircularProgressWithLabel from "controls/global/circular-progress-with-label/CircularProgressWithLabel";
import StewartTableFooterPaginator from "controls/global/stewart-table/StewartTableFooterPaginator";
import { SignatureSearchCriteria } from "entities/UIModel";
import useSignature from "utils/custom-hooks/useSignature";
import SignatureDefaultDialog from "../default-dialog";
import { getColumnConfig } from "utils/columnsGrid";
import { DefaultSignatureRow } from "entities/UIModel/DefaultSignatureRow";
// import { usePaginationProvider } from "pages/signatures/providers/manage-signature/PaginationProvider";
// import { useUser } from "utils/context/UserContext";

const NO_SIGNATURES_MESSAGE =
  "You must add a signature in Manage Signatures before setting defaults.";
const NO_DEFAULTS_MESSAGE =
  "There are currently no default signatures configured.";
// const DELETE_USER_ONLY_MESSAGE =
//   "Are you sure you want to delete this defaulted signature?";
// const DELETE_AGENCY_WIDE_MESSAGE =
//   "This default affects one or more users.  Are you sure you want to delete this defaulted signature?";

const DELETE_DEFAULT_SIGNATURE_TITLE = 'Delete this default signature?';
const DELETE_AGENCY_WIDE_SUBTITLE = 'This default signature affects one or more users.';

const EmptySignatures = styled(Box)({
  color: colors.grey11,
  fontWeight: fontWeight.normal1,
  padding: `${padding.small2} ${padding.zero}`,
  marginLeft: margin.small2,
});


const StyledTableContainer = styled(Box)({

  "& table thead th, & table thead .MuiTableCell-root": {
    zIndex: 2,
  },
  "& table tbody tr:last-child td, & table tbody tr:last-child .MuiTableCell-root": {
    background: "#fff",
  },
  "& table tbody tr:hover td": {
    backgroundColor: `${colors.grey10} !important`,
  },
  "& table tbody td, & table tbody .MuiTableCell-root": {
    position: "relative",
    zIndex: 1,
    backgroundColor: "#fff",
  },
  "& > .MuiTableContainer-root > table.MuiTable-root:not(.details-table)": {
    "& > thead": {
      "& th.MuiTableCell-root.MuiTableCell-head": {
        color: colors.grey08,
        fontSize: fontSize.base,
        fontWeight: fontWeight.normal2,
        "& div.MuiBox-root": {
          color: colors.grey08,
          fontSize: fontSize.base,
          fontWeight: fontWeight.normal2,
        },
        "& div.MuiInputBase-root.MuiOutlinedInput-root.MuiOutlinedInput-adornedEnd": {
          border: borderSize.zero,
          borderBottom: `${borderSize.xsmall} solid ${colors.grey15}`,
          borderRadius: 0,
          "&:focus-within": {
            borderBottom: `${borderSize.small} solid ${colors.blue01}`,
          },
          "& fieldset": {
            border: borderSize.zero,
          },
        },
      },
    },
    "& > tbody": {
      "& > tr": {
        "&:hover td": {
          background: colors.grey10,
        },
        "&:last-child": {
          "& > td:not(.emptyCell)": {
            borderBottom: `1px solid ${colors.grey08}`,
          },
          "& > td:not(.emptyCell):first-child": {
            borderBottomLeftRadius: borderSize.zero,
          },
          "& > td:not(.emptyCell):last-child": {
            borderBottomRightRadius: borderSize.zero,
          },
        },
      },
    },
    "& td.MuiTableCell-root.MuiTableCell-body": {
      "& div": {
        color: colors.grey08,
        fontWeight: fontWeight.normal1,
      },
    },
    "& td.MuiTableCell-root.MuiTableCell-footer": {
      borderBottom: defaultStyle.table.border,
      borderBottomLeftRadius: borderRadius.small,
      borderBottomRightRadius: borderRadius.small,
      borderLeft: defaultStyle.table.border,
      borderRight: defaultStyle.table.border,
      padding: padding.xsmall2,
      paddingRight: padding.small2,
    },
  },
  "& .rightColumn": {
    "& span": {
      display: "flex",
      justifyContent: "end",
      paddingRight: padding.small2,
    },
    "& .MuiFormLabel-root.MuiInputLabel-root": {
      textAlign: "end",
    },
  },
});

type Props = {
  colsConfig: IColumn[];
};

const ProgressWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 1300
});

function SignatureDefaultsContent({ colsConfig }: Props) {
  const [selectedRow, setSelectedRow] = useState<SignatureDefaultGroup | undefined>(undefined);
  const [message, setMessage] = useState<string | null>(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState<{ title: string, subTitle: string }>({ title: "", subTitle: "" });
  // const [deleteMessage, setDeleteMessage] = useState("");
  const [disableConfirmationDialogYes, setDisableConfirmationDialogYes] = useState(false);
  const [{ signatures, signatureModified },] = useSignatures();
  const { refreshAllSignaturesStateContext, refreshAllDefaultSignaturesStateContext } = useSignature();
  const InitialMessage = "Loading results...";
  const [noRecordsMessage, setNoRecordsMessage] = useState<string[]>([InitialMessage]);
  const [sortColumn, setSortColumn] = useState<string | undefined>("SignatureImageName");
  const [orderBy, setOrderBy] = React.useState<keyof SignatureDefaultGroup | undefined>("signatureName");
  const NO_RECORD_MESSAGE = "No Messages found";
  const [order, setOrder] = React.useState<Order>("desc");
  const FETCHING_DATA_ERROR_MESSAGE = "There was a problem fetching your messages. Please try again";
  const [readyToSearch, setReadyToSearch] = useState<boolean>(false);
  const [userInputDebounceTimeMs, setUserInputDebounceTimeMs] = useState<number>(750);
  const [settingsLoaded, setSettingsLoaded] = useState<boolean>(false);
  const [partialFilterUpdate, setPartialFilterUpdate] = useState<boolean>(false);
  const { generalConfig } = useConfigContext();
  const [filters, setFilters] = useState<any>(undefined);
  const [openListModal, setOpenListModal] = useState(false);
  const [listModalType, setListModalType] = useState<"agency" | "state" | "location" | null>(null);
  // const [visitedLinks, setVisitedLinks] = useState<
  //   { type: "agency" | "state" | "location"; key: string }[]
  // >([]);
  const [selectedSignatureName, setSelectedSignatureName] = useState<string>("");
  const [signatureAgencyId, setSignatureAgencyId] = useState(0);

  const visitedLinksRef = useRef<{type: "agency" | "state" | "location"; key: string;}[]>([]);
  const [defaults, setDefaults] = useState<SignatureDefaultGroup[]>([]);

  // Pagiination state here
  const [rowsPerPage, setRowsPerPage] = useState(10);  
  const [page, setPage] = useState<number>(1);
  // const [, { getRowsPerPageSetting }] = useUser();
  // const { dispatch: setPaginationSignatureDefault } = usePaginationProvider();

  const {
    isOpen,
    showEdit,
  } = useSignatureDefaultDialogProvider();
  const [{ userOnlyLevelCode ,isLoading ,loadingProgress  }, { deleteDefault, getDefaults, editSetup  ,setColumnDefinition  }] = useSignatureDefaults();
  const [{ selectedAgency: globalAccessAgency }] = useGlobalAccess();

  const [, { setRequestTimeoutMs }] = useMyFiles();

  const getFileSearchCriteria = () => {
    // let criteria: any;
    // if (sortColumn) {
    const criteria: SignatureSearchCriteria = {
        //...criteria,
        sortColumn: sortColumn,
        listCount: rowsPerPage,
        requestedPage: page,        
      };
    // }
    return criteria;
  };
  
  const getDatabaseSortColumnName = (name: string) => {

    const mappedColumnNames: { [key: string]: string } = {
      signatureImageId: "SignatureImageID",
      signatureName: "SignatureImageName",
      signatureImageName: "SignatureImageName",
      signatureImageDescription: "SignatureImageDescription",
      signatureImageSourceTypeCode: "SignatureImageSourceTypeCode",
      signatureImageFontTypeCode: "SignatureImageFontTypeCode",
      signatureImageFormatTypeCode: "SignatureImageFormatTypeCode",
      signatureImageData: "SignatureImageData",
      signatureLevelTypeCode: "SignatureLevelTypeCode",
      signatureConfiguration: "SignatureConfiguration",
      isDefaulted: "IsDefaulted",
      isDefaultedByOther: "IsDefaultedByOther",
      signatureCreatedDate: "SignatureCreatedDate",
      signatureCreatedByUser: "SignatureCreatedByUser",
      signatureImage: "SignatureImage",
      access: "SignatureLevelTypeCode",
      createdBy: "SignatureCreatedByUser",
      "createdDate/Time": "SignatureCreatedDate",
      agency: "AgencyName",
      agencyLocation: "AgencyLocation",
      SignatureCreatedByUser: "SignatureCreatedByUser",
      SignatureCreatedDate: "SignatureCreatedDate"
    };

    return mappedColumnNames[name] ?? name;
  };

  const showLoader = () => {
    return (<ProgressWrapper><CircularProgressWithLabel value={loadingProgress} /></ProgressWrapper>)
  }

  const getDefaultFilters = (advanced: boolean): any => {
    const sortColumn = "-SignatureImageName";
    const defaultFilters = {
      sortColumn: sortColumn,
    };
    return defaultFilters;
  };

  const handleOpenListModal = (
    type: "agency" | "state" | "location",
    rowKey: string,
    signatureName: string,
    agencyID: number,
  ) => {
    // setVisitedLinks((prev) => {
    //   const exists = prev.some((v) => v.type === type && v.key === rowKey);
    //   if (exists) return prev;
    //   return [...prev, { type, key: rowKey }];
    // });

    setVisitedLinksRef(type, rowKey);

    setListModalType(type);
    setSelectedSignatureName(signatureName);
    setOpenListModal(true);
    setSignatureAgencyId(agencyID)

  };

  const setVisitedLinksRef = (
    type: "agency" | "state" | "location",
    rowKey: string,) => {
      if (!(visitedLinksRef.current && 
        visitedLinksRef.current.some((v) => v.type === type && v.key === rowKey) )
      ) {
        visitedLinksRef.current.push({ type: type, key: rowKey});
      }
  }

  const getPageDefaults = async () => {
    const criteria = getFileSearchCriteria();

    try {
      const result = await getDefaults(globalAccessAgency[0]?.CompanyID, criteria, false);
      setDefaults(result);
      if (!result?.length) {
        setNoRecordsMessage([NO_RECORD_MESSAGE]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      showToast({
        type: "error",
        title: FETCHING_DATA_ERROR_MESSAGE,
      });
    }
  }

  const performSearch = async () => {
    // const criteria = getFileSearchCriteria();

    // try {
    //   const result = await getDefaults(globalAccessAgency[0]?.CompanyID, criteria)
    //   if (!result?.length) {
    //     setNoRecordsMessage([NO_RECORD_MESSAGE]);
    //   }
    // } catch (error) {
    //   console.error("Error fetching data:", error);
    //   showToast({
    //     type: "error",
    //     title: FETCHING_DATA_ERROR_MESSAGE,
    //   });
    // }
    getPageDefaults();
  };

  const debounceSetReadyToSearch = useCallback(
    debounce(() => setReadyToSearch(true), userInputDebounceTimeMs),
    [userInputDebounceTimeMs],
  );

  const handleEdit = async (signatureDefaultGroup: SignatureDefaultGroup) => {
    setSelectedRow(signatureDefaultGroup);
    editSetup(signatureDefaultGroup);
    showEdit();
  };

  const handleRequestDelete = (signatureDefaultGroup: SignatureDefaultGroup) => {
    // const msg = signatureDefaultGroup.signatureLevelTypeCode === userOnlyLevelCode
    //   ? DELETE_USER_ONLY_MESSAGE
    //   : DELETE_AGENCY_WIDE_MESSAGE;

    signatureDefaultGroup.signatureLevelTypeCode === userOnlyLevelCode ? setDeleteMessage({
      title: DELETE_DEFAULT_SIGNATURE_TITLE,
      subTitle: ''
    }) : setDeleteMessage({
      title: DELETE_DEFAULT_SIGNATURE_TITLE,
      subTitle: DELETE_AGENCY_WIDE_SUBTITLE
    })

    setDisableConfirmationDialogYes(false);
    setSelectedRow(signatureDefaultGroup);
    // setDeleteMessage(msg);
    setShowDeleteDialog(true);
  };

  const handleConfirmDelete = async () => {
    setDisableConfirmationDialogYes(true);
    if (selectedRow) {
      try {
        const status = await deleteDefault(selectedRow?.existingUserAgencySignatureDefaultIDs);
        
        if (status >= 200 && status < 300) {
          showToast({
            type: "success",
            title: UIConstants.DELETE_DEFAULT_SIGNATURE_SUCCESS_MESSAGE.toString(),
          });
          setShowDeleteDialog(false);

          refreshAllSignaturesStateContext(globalAccessAgency[0]?.CompanyID);
          refreshAllDefaultSignaturesStateContext(globalAccessAgency[0]?.CompanyID);
          // getDefaults(globalAccessAgency[0]?.CompanyID);
          getPageDefaults();
        } else {
          showToast({
            type: "error",
            title: UIConstants.DELETE_DEFAULT_SIGNATURE_ERROR_MESSAGE.toString(),
          });
        }
      } catch (error) {
        showToast({
          type: "error",
          title: UIConstants.DELETE_DEFAULT_SIGNATURE_ERROR_MESSAGE.toString(),
        });
      }
    }
    setSelectedRow(undefined);
    setShowDeleteDialog(false);
  };

  const handleCancelDelete = () => {
    setSelectedRow(undefined);
    setShowDeleteDialog(false);
  };

  // const getRowClassNames = (key: string) => {
  //   return selectedRow?.key === key ? "selected-row" : "";
  // };

    const isFirstRender = useRef(true);
  
    useEffect(() => {
      // skip 1st run
      if (isFirstRender.current) {
        isFirstRender.current = false;
        return;
      }

      getPageDefaults();
    }, [getDefaults, signatureModified, globalAccessAgency]);
  

  useEffect(() => {
    if (!signatures || signatures.length < 1) {
      setMessage(NO_SIGNATURES_MESSAGE);
      setNoRecordsMessage([NO_RECORD_MESSAGE])
      return;
    }
    if (!defaults || defaults.length < 1) {
      setMessage(NO_DEFAULTS_MESSAGE);
      return;
    }
    setMessage(null);
  }, [signatures, defaults]);

  useEffect(() => {
    if (!isOpen) {
      setSelectedRow(undefined);
    }
  }, [isOpen]);
  // const [{ profileSettings }] = useProfileSettingsCache();

  // const permissionCodes = profileSettings?.userPermissionItemTypes as string[];

  // const hasEditSignatureAccess = permissionCodes?.includes(PERMISSIONS.SIGNATURES_EDIT);
  // const hasDeleteSignatureAccess = permissionCodes?.includes(PERMISSIONS.SIGNATURES_DELETE);


  const canSearch = (): boolean => {
    return !partialFilterUpdate && filters !== undefined && Object.values(filters).length > 0;
  };

  const handleRequestSort = async (columnName: any, disableToggling: boolean = false) => {
    let sortBy = getDatabaseSortColumnName(columnName);
    if (!disableToggling && sortColumn === sortBy) {
      sortBy = `-${sortBy}`;
    }

    setOrder(sortBy.startsWith("-") ? "desc" : "asc");
    setOrderBy(columnName.replace("-", ""));
    setSortColumn(sortBy);
  };


  useEffect(() => {
    if (readyToSearch) {
      const search = async () => {
        await performSearch();
        setReadyToSearch(false);
      };

      search();
    }
  }, [readyToSearch]);

  const loadSettings = async () => {
    const debounceTime = generalConfig.userInputDebounceTimeMs;
    const timeoutMs = generalConfig.filesSearchTimeoutMs;

    if (debounceTime) {
      setUserInputDebounceTimeMs(debounceTime);
    }
    if (timeoutMs) {
      setRequestTimeoutMs(timeoutMs);
    }
  };

  // Pagination function
  const handlePageChange = async (page: number) => {
    setPage(page);
  };  

  const handleRowsPerPageChange = async (count: number) => {
    // setRowsPerPageSetting(count);
    setRowsPerPage(count);
    setPartialFilterUpdate(false);
    setPage(1);
  };
  
  // UseEffects 
  // useEffect(() => {
  //   const getCount = async () => {
  //     const count = await getRowsPerPageSetting();
  //     setRowsPerPage(count);
  //   };

  //   getCount();
  // }, [getRowsPerPageSetting]);

  useEffect(() => {
    const init = async () => {
      await loadSettings();
      setSettingsLoaded(true);
    };

    init();
  }, []);

  useEffect(() => {
    // setPaginationSignatureDefault({
    //   type: PaginationProviderActionType.SET_SIGNATURE_DEFAULT_GRID,
    //   signatureDefaultPagination: {
    //     page: page,
    //     rowsPerPage: rowsPerPage,
    //     sortColumn: sortColumn,
    //   }
    // });
    if (canSearch()) {
      if (partialFilterUpdate) {
        setPartialFilterUpdate(false);
      }

      debounceSetReadyToSearch();
    }
  }, [filters, page, rowsPerPage, sortColumn, settingsLoaded]);

  useEffect(() => {
    // setPaginationSignatureDefault({
    //   type: PaginationProviderActionType.INIT_SIGNATURE_DEFAULT_GRID,
    // });

    const defaultFilters = getDefaultFilters(false);
    setFilters(defaultFilters);
  }, []);

  const handleColumnResize = (column: any, newWidth: number) => {
    if (column && newWidth > 0) {
      setColumnDefinition([column], "width", Math.floor(newWidth));
    }
  };
  
  
  const DEFAULT_COLUMNS: StewartTableColumn<any>[] =  _orderBy([
    {
      field: "signatureName",
      valueGetter: (row: SignatureDefaultGroup) => {
        return (
          <Box
            sx={{
              cursor: "pointer",
            }}
          >
            <TooltipCell title={row.signatureImageName || ""} />
          </Box>
        );
      },
      ...getColumnConfig<DefaultSignatureRow>(colsConfig, "signatureName"),
    },
    // <img src={record.signatureImageData}></img>
    {
      field: "signatureImage",
      valueGetter: (row: SignatureDefaultGroup) => {
        return (
          <Box sx={{ width: 250, height: 44, overflow: "hidden" }}>
            <img
              src={toBase64(row.signatureImage || "") || ""}
              alt="Signature"
              style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "left" }}
            />
          </Box>
        );
      },
      ...getColumnConfig<DefaultSignatureRow>(colsConfig, "signatureImage"),
    },
    {
      field: "access",
      valueGetter: (row: SignatureDefaultGroup) => {
        return (
          <Box>
            <TooltipCell title={row.signatureLevelTypeName || ""} />
          </Box>
        );
      },
      ...getColumnConfig<DefaultSignatureRow>(colsConfig, "access"),
    },
    {
      field: "agency",
      valueGetter: (row: SignatureDefaultGroup) => {
        const isAll = row.agencyName === "All Agencies";
        //const isVisited = visitedLinks.some((v) => v.type === "agency" && v.key === row.key);
        const isVisited = visitedLinksRef.current?.some((v) => v.type === "agency" && v.key === row.key);

        return (
          <Box>
            {isAll ? (
              <Typography
                sx={{
                  color: isVisited ? "#6A4CA3" : colors.blue01,
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => handleOpenListModal("agency", row.key, row.signatureImageName, row.signatureImageID)}
              >
                All Agencies
              </Typography>
            ) : (
              <TooltipCell title={row.agencyName || ""} />
            )}
          </Box>
        );
      },
      ...getColumnConfig<DefaultSignatureRow>(colsConfig, "agency"),
    },
    {
      field: "state",
      valueGetter: (row: SignatureDefaultGroup) => {
        const isAll = row.state === "All States";
        // const isVisited = visitedLinks.some((v) => v.type === "state" && v.key === row.key);
        const isVisited = visitedLinksRef.current?.some((v) => v.type === "state" && v.key === row.key);

        return (
          <Box>
            {isAll ? (
              <Typography
                sx={{
                  color: isVisited ? "#6A4CA3" : colors.blue01,
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => handleOpenListModal("state", row.key, row.signatureImageName, row.signatureImageID)}
              >
                All States
              </Typography>
            ) : (
              <TooltipCell title={row.state || ""} />
            )}
          </Box>
        );
      },
      ...getColumnConfig<DefaultSignatureRow>(colsConfig, "state"),
    },
    {
      field: "agencyLocation",
      valueGetter: (row: SignatureDefaultGroup) => {
        const isAll = row.agencyLocation === "All Locations";
        // const isVisited = visitedLinks.some((v) => v.type === "location" && v.key === row.key); //, row.agencyID);
        const isVisited = visitedLinksRef.current?.some((v) => v.type === "location" && v.key === row.key); //, row.agencyID);

        return (
          <Box>
            {isAll ? (
              <Typography
                sx={{
                  color: isVisited ? "#6A4CA3" : colors.blue01,
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => handleOpenListModal("location", row.key, row.signatureImageName, row.signatureImageID)}
              >
                All Locations
              </Typography>
            ) : (
              <TooltipCell title={row.agencyLocation || ""} />
            )}
          </Box>
        );
      },
      ...getColumnConfig<DefaultSignatureRow>(colsConfig, "agencyLocation"),
    },
    {
      field: "SignatureCreatedByUser",
      valueGetter: (row: SignatureDefaultGroup) => {
        return (
          <Box>
            <TooltipCell title={row.signatureCreatedByUser || ""} />
          </Box>
        );
      },
      ...getColumnConfig<DefaultSignatureRow>(colsConfig, "SignatureCreatedByUser"),
    },
    {
      field: "SignatureCreatedDate",
      valueGetter: (row: SignatureDefaultGroup) => {
        return (
          <Box>
            <TooltipCell title={row.signatureCreatedDate ? formatDateRegEx(row.signatureCreatedDate) || "" : ""} />
          </Box>
        );
      },
      ...getColumnConfig<DefaultSignatureRow>(colsConfig, "SignatureCreatedDate"),
    },
    {
      field: "Actions",
      name: "",
      sortable: false,
      width: 150,
      right: 0,
      sticky: true,
      draggable: false,
      resizable: false,
      valueGetter: (row: SignatureDefaultGroup) => {
        const signatureActionConfig = getSignatureActionLabels(row.isModify ?? false);
        return (
          <>
            <CustomTooltip
              title={"Edit"}
              placement="top"
              arrow
              onClick={() => handleEdit(row)}
            >
              <IconButton
                className="actionButton"
                sx={{
                  color: colors.blue01, height: "7px", width: "45px", "&.Mui-disabled": {
                    color: colors.blue01,
                    opacity: 0.5,
                  },
                }}
                disabled={signatureActionConfig.isFieldDisabled}
              >
                <EditIcon />
              </IconButton>
            </CustomTooltip>

            <CustomTooltip
              title={"Delete"}
              placement="top"
              arrow
            >
              <IconButton
                className="actionButton"
                sx={{
                  color: colors.blue01, height: "7px", width: "45px", "&.Mui-disabled": {
                    color: colors.blue01,
                    opacity: 0.5,
                  },
                }}
                onClick={() => handleRequestDelete(row)}
                disabled={signatureActionConfig.isFieldDisabled}
              >
                <DeleteIcon />
              </IconButton>
            </CustomTooltip>
          </>
        );
      },
    },
  ], 'position');

  // useEffect(() => {
  //   console.log("--RERENDER -> SignatureDefaultsContent.tsx");
  // })  
  // console.log("defaults:", defaults);
  
  return (
    <>
      {!message ? (
        <StyledTableContainer>
          <StewartTable
            cols={DEFAULT_COLUMNS}
            columnsUrl="defaultsignatures"
            rows={defaults}
            useDbPagingSorting={true}
            page={page}
            rowsPerPage={rowsPerPage}
            showActionRow={false}
            orderBy={orderBy}
            order={order}
            onRequestSort={handleRequestSort}
            noRowsMessage={noRecordsMessage}
            onColumnResize={handleColumnResize}
            autoHeight
          />
          <div style={{ marginTop: "20px" }}>
            <StewartTableFooterPaginator
              totalRows={defaults[0]?.totalRows || 0} // {rows[0]?.totalRows || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              totalPages={defaults[0]?.totalPages}
            />
          </div>
        </StyledTableContainer>
      ) : (
        <EmptySignatures>{message}</EmptySignatures>
      )}
      {isLoading && showLoader()}

      <SignatureDefaultDialog refreshPage={getPageDefaults} />

      {/* {showDeleteDialog && (
        <ConfirmationDialog
          type={"ERROR"}
          confirmationMessage={deleteMessage}
          isOpen={showDeleteDialog}
          onYes={handleConfirmDelete}
          onNo={handleCancelDelete}
          disableYes={disableConfirmationDialogYes}
        />
      )} */}

      <SignatureConfirmationDialog
        width={600}
        isOpen={showDeleteDialog}
        title={deleteMessage.title}
        subtitle={deleteMessage.subTitle}
        iconType="delete"
        onPrimaryAction={async () => await handleConfirmDelete()}
        primaryButtonText={"Delete"}
        primaryButtonColor="primary"
        disablePrimaryButton={disableConfirmationDialogYes}
        onSecondaryAction={handleCancelDelete}
        secondaryButtonText={"Cancel"}
        disableSecondaryButton={false}
        showCloseIcon={true}
        onClose={handleCancelDelete}
      />

      <SignatureAllViewModal
        open={openListModal}
        type={listModalType}
        onClose={() => setOpenListModal(false)}
        signatureName={selectedSignatureName}
        signatureAgencyId={signatureAgencyId}
        key={`${signatureAgencyId}-${listModalType}`}
      />
    </>
  );
}

export default SignatureDefaultsContent;
